import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmployeeAgreementComponent } from './employee-agreement.component';

const routes: Routes = [{ path: '', component: EmployeeAgreementComponent, pathMatch: 'full' }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeAgreementRoutingModule { }
